import { StandardProps } from "@/components/componentMap";
import { useVariant } from "@/hooks/useVariant/useVariant";
import styles from "./PremiumDesktopGallery.module.scss";

export const PremiumDesktopGallery = (
  props: Pick<
    StandardProps,
    | "product"
    | "configProps"
    | "flags"
    | "experiencesRawObject"
    | "runtimeConfig"
  >,
) => {
  const { product, configProps } = props;
  const { variant } = useVariant(product);

  const showOnlyPrimaryImage = configProps?.showOnlyPrimaryImage === true;
  const showOnlyAlternativeImages =
    configProps?.showOnlyAlternativeImages === true;
  const showAllImages = !showOnlyPrimaryImage && !showOnlyAlternativeImages;

  if (!variant) return null;
  const images = variant.images;

  return (
    <>
      {(showAllImages || showOnlyPrimaryImage) && (
        <div className={styles.primaryImage}>
          <img className={styles.image} src={images.primary} alt="" />
        </div>
      )}
      {(showAllImages || showOnlyAlternativeImages) && (
        <div className={styles.alternativeImages}>
          {images.alternatives.map((image, index) => (
            <img
              key={`${image}-${index}`}
              className={styles.image}
              src={image}
              alt=""
            />
          ))}
        </div>
      )}
    </>
  );
};
